var map = {
	"./getModules.graphql": 30652,
	"./getModulesNonEditor.graphql": 64380,
	"./instantMessages/getAllMessages.graphql": 72196,
	"./instantMessages/getUnreadMessages.graphql": 10544,
	"./onAfterSignIn.graphql": 77898,
	"./onBeforePageEnter.graphql": 33068,
	"./onInitApp.graphql": 4285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37925;